$(function() {
  var render_region_office = function(data) {
    $('.contact-office__direct-links').hide();
    var container = $('.contact-main__container');
    container.html(data);
    // register sliding content handler
    container.find('.gridder').gridderExpander({
      scroll: true,
      scrollOffset: 30,
      scrollTo: "listitem",                  // panel or listitem
      animationSpeed: 400,
      animationEasing: "easeInOutExpo",
      showNav: true,                      // Show Navigation
      nextText: "",                   // Next button text
      prevText: "",               // Previous button text
      closeText: "",                 // Close button text
      onContent: function(){
        //Gridder Content Loaded
        selectize_all_selects();
        ContactFormHelper.registerContactFormHandler();
      }
    });
  };

  $('.region-office-select-headquarters').on('ajax:success', function(event) {
    const data = event.detail[2].responseText;
    render_region_office(data);
    ExpandContent.expandContentHandler();
    FormDisclaimer.disclaimerHandler();
  });
  $('.hero-image__select').on('ajax:success', function(event) {
    const data = event.detail[2].responseText;
    render_region_office(data);
    ExpandContent.expandContentHandler();
    FormDisclaimer.disclaimerHandler();
  });
});
